import React, { memo, useCallback } from "react";
import { Alert } from "antd";
import GoogleMapReact from "google-map-react";
import LiveMarker from "./Markers/LiveMarker";

export default memo(function GoogleMap({
  pickupAddress,
  dropOffAddress,
  loadLocation,
  showMarker,
  defaultZoom = 10,
  yesIWantToUseGoogleMapApiInternals = true,
}) {
  const onGoogleApiLoaded = useCallback(
    ({ map, maps }) => {
      let directionsService = new maps.DirectionsService();
      let directionsRender = new maps.DirectionsRenderer();
      directionsRender.setMap(map);
      directionsService.route(
        {
          origin: `${pickupAddress?.latitude},${pickupAddress?.longitude}`,
          destination: `${dropOffAddress?.latitude},${dropOffAddress?.longitude}`,
          travelMode: "DRIVING",
        },
        function (response, status) {
          if (status === "OK") {
            directionsRender.setDirections(response);
          } else {
            window.alert("Directions request failed due to " + status);
          }
        },
      );
    },
    [pickupAddress, dropOffAddress],
  );

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Alert
        message="For privacy reasons, live GPS tracking is only shown when transporters have opted in and enabled location services. If a driver disables tracking, location updates may be delayed or unavailable."
        type="info"
        showIcon
      />
      <div style={{ height: "400px" }}>
        <GoogleMapReact
          bootstrapURLKeys={{
            key: process.env.REACT_APP_GOOGLE_API_KEY,
          }}
          defaultCenter={{
            lat: pickupAddress?.latitude,
            lng: pickupAddress?.longitude,
          }}
          defaultZoom={defaultZoom}
          yesIWantToUseGoogleMapApiInternals={
            yesIWantToUseGoogleMapApiInternals
          }
          onGoogleApiLoaded={onGoogleApiLoaded}
        >
          {showMarker && loadLocation?.latitude && loadLocation?.longitude && (
            <LiveMarker
              lat={loadLocation.latitude}
              lng={loadLocation.longitude}
            />
          )}
        </GoogleMapReact>
      </div>
      <Alert
        message="Note: Drivers may occasionally deviate from the suggested route to deliver or pick up additional vehicles, or to consolidate shipments for efficiency."
        type="info"
        showIcon
      />
    </div>
  );
});
